import { updatesData, topicsData, featuresData } from '@/mocks/homeData';

export default function SectionsTwo() {
  return (
    <>
      <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-20">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              最新动态
            </h2>
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">
              片库每日更新、经典修复进度、专题活动信息，不错过每一次光影重逢
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-background-300"></div>

            <div className="space-y-6">
              {updatesData.map((item) => (
                <div key={item.id} className="relative pl-10 md:pl-14 group cursor-pointer">
                  <div className="absolute left-2 md:left-4 top-1 w-5 h-5 rounded-full bg-accent-500 border-4 border-background-100 group-hover:scale-125 transition-transform"></div>

                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-400 font-medium">{item.date}</span>
                    <span className="px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                      {item.tag}
                    </span>
                  </div>

                  <h3 className="font-heading text-base font-semibold text-foreground-950 mb-1.5 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section id="topics" className="py-14 md:py-20 px-4 md:px-6 scroll-mt-20">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              热门话题
            </h2>
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">
              围绕经典电影展开的热议话题，看看大家都在关注哪些影人和类型
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {topicsData.map((topic) => (
              <a
                key={topic.id}
                href="#topics"
                className="group inline-flex items-center gap-2 px-4 py-2.5 bg-background-50 rounded-full border border-background-200 hover:border-secondary-300 hover:bg-secondary-50/60 transition-all duration-200 cursor-pointer"
              >
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
                  <i className={`${topic.icon} text-sm`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-700 whitespace-nowrap">
                  {topic.name}
                </span>
                <span className="text-xs text-foreground-400 bg-background-100 px-1.5 py-0.5 rounded-full">
                  {topic.count}
                </span>
              </a>
            ))}
          </div>
        </div>
      </section>

      <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-100 scroll-mt-20">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              为什么选择我们
            </h2>
            <p className="text-sm text-foreground-500 max-w-xl mx-auto">
              用心打造最好的怀旧观影体验，让经典电影以最好的状态与你重逢
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
            {featuresData.map((feature) => (
              <div
                key={feature.id}
                className="group bg-background-50 rounded-xl border border-background-200 p-5 hover:border-primary-200 transition-all duration-200 text-center cursor-pointer"
              >
                <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                  <i className={`${feature.icon} text-xl`}></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 mb-2">
                  {feature.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}